// extracted by mini-css-extract-plugin
export var chevron = "_ad-2";
export var dropdownItems = "_ad-0";
export var item = "_ad-1";